import {img} from "@/utils/pluginImg.js";

/**
 * Airline logo lookup, keyed on the flight API's `airline.name`.
 * Twin of the plugin's utils/airlineLogo.js — keep the two maps in step.
 *
 * Replaces the `/^air canada$/i` test that used to be inlined at every flight card. Keys
 * are the provider's own names lowercased and trimmed — an EXACT match, not a substring
 * one, because "Air Canada Rouge" and "Air Canada Express" are different carriers with
 * their own artwork, and a loose match would silently badge them wrong.
 *
 * A handful of short forms are aliased alongside the full names: the provider is mostly
 * consistent, but "Delta" / "United" / "Porter" do come back on their own, and within
 * this set each is unambiguous.
 *
 * An unknown airline resolves to null and the call site renders no logo at all — the
 * same thing every non-Air-Canada flight did before. `img()` returns '' for a file that
 * isn't in assets/images yet, which is normalised to null here so a not-yet-added logo
 * fails quietly instead of rendering a broken image.
 */
const AIRLINE_LOGOS = {
    'air canada': 'canada-leaf.svg',
    'westjet': 'airline-westjet.svg',
    'porter airlines': 'airline-porter.svg',
    'porter': 'airline-porter.svg',
    'air transat': 'airline-air-transat.svg',
    'transat': 'airline-air-transat.svg',
    'delta air lines': 'airline-delta.svg',
    'delta': 'airline-delta.svg',
    'american airlines': 'airline-american.svg',
    'american': 'airline-american.svg',
    'united airlines': 'airline-united.svg',
    'united': 'airline-united.svg',
    'flair airlines': 'airline-flair.svg',
    'flair': 'airline-flair.svg',
};

/** URL for an airline's logo, or null when we don't ship one for it. */
export function airlineLogo(name) {
    const file = AIRLINE_LOGOS[String(name || '').trim().toLowerCase()];
    return file ? (img(file) || null) : null;
}

export default airlineLogo;
